import appFileCtrl from './addNewFilesCtrl';
import appFileView from './addNewFilesModal.html';
import confirmDeleteView from '../app.modal/confirmDeleteModal.html';
import paginationTemplate from '../app.pagination/pagination.html';
import moment from 'moment';

export default function ($rootScope, $scope, $stateParams, $http, $uibModal, $timeout, $state, $q, $filter, $location, CONFIG, ContentFulFactory, ngToast, UtilitiesFactory, FirebaseFactory) {
    'ngInject';

    moment.locale('de');

    let paginationResultsPerPage = CONFIG.paginationResultsPerPage;
    let resultsTotal = 0;
    let page = $stateParams.page || 1;
    let labelSingle = 'file';
    let T = $scope.$root.T;
    let MobileDetect = require('mobile-detect');
    let md = new MobileDetect(window.navigator.userAgent);
    let isMobile = !!md.mobile();

    $scope.isMobile = isMobile;
    $scope.page = page;
    $scope.isProgress = false;
    $scope.isSearch = false;
    $scope.limit = paginationResultsPerPage;
    $scope.isGetShowMore = true;
    $scope.search = $stateParams.search;

    $scope.paginationTemplate = paginationTemplate;
    $scope.isOpen = false;

    /***
     * Get All files (deprecated)
     */
    let getAllFiles = () => {
        let endpoint = `assets?limit=1000&sys.type[ne]=${(new Date()).valueOf()}&order=-sys.updatedAt`;
        $scope.isSearchBarProgress = true;
        $http.get(CONFIG.cmApiUrl + endpoint).then( (data) => {
            let _data = data.data;
            $scope.files_all = _data.items;
            $scope.isSearchBarProgress = false;
            if (!!$scope.search) {
                $scope.changed($scope.search);
            }

            if (isMobile) {
                $scope.isProgress = false;
                $scope.files = $scope.files_all;
                let total = $scope.files.length;
                $scope.page = 1;
                $scope.pagesTotal = Math.ceil(total / paginationResultsPerPage);
                $scope.paginationRange = _.range(1, Math.round(total / paginationResultsPerPage) + 1);
            }
        });
    };

    /***
     * Get Files
     */
    let getFiles = (isRemoved = false) => {
        let endpoint = `assets?sys.type[ne]=${(new Date()).valueOf()}&order=-sys.createdAt`;
        if (!!$scope.search) {
            endpoint += `&query=${$scope.search}`;
        }
        endpoint += `&skip=${paginationResultsPerPage * (page - 1)}&limit=${paginationResultsPerPage}`;

        $scope.isProgress = true;
        $http.get(`${CONFIG.cmApiUrl}${endpoint}`).then( (data) => {
            let _data = data.data;
            $scope.files = _data.items;

            _.forEach($scope.files, (file) => {
                file.isImage = false;
                console.log(file);
                if (file.fields.hasOwnProperty('file')) {
                    console.warn('__file', file.fields.file);
                    if (file.fields.file.en.hasOwnProperty('url')) {
                        file.isImage =
                            file.fields.file.en.contentType.toLowerCase().indexOf('png') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('gif') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpg') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpeg') > -1;
                    } else if (file.fields.file.en.hasOwnProperty('upload')) {
                        if (file.fields.file.en.hasOwnProperty('contentType')) {
                            file.isImage =
                                file.fields.file.en.contentType.toLowerCase().indexOf('png') > -1 ||
                                file.fields.file.en.contentType.toLowerCase().indexOf('gif') > -1 ||
                                file.fields.file.en.contentType.toLowerCase().indexOf('jpg') > -1 ||
                                file.fields.file.en.contentType.toLowerCase().indexOf('jpeg') > -1;
                        } else {
                            let type = _.last(file.fields.file.en.upload.split('.'));
                            if (type === 'png' || type === 'gif' || type === 'jpg' || type === 'jpeg') {
                                file.isImage = true;
                            }
                        }
                    }
                }

                file.sys.createdAt = moment(file.sys.createdAt).format("DD. MMMM YYYY");
            });

            resultsTotal = _data.total;
            $scope.pagesTotal = Math.ceil(resultsTotal / paginationResultsPerPage);
            $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);

            if (isRemoved) {
                let firstEle = _.first($scope.files);
                console.log('firstEle', firstEle);
                $state.go('^.file', {id: firstEle.sys.id});
                $scope.isProgress = false;
            } else {
                $scope.isProgress = false;
            }
        });
    };

    /***
     * Remove Files
     * @param file
     */
    let removeFile = (file) => {
        console.log('removeFile');
        let id = file.sys.id;
        $scope.isProgress = true;

        /**
         * File Archived and not published
         */
        if (!!file.sys.archivedAt || !!!file.sys.publishedAt) {
            $http.delete(`${CONFIG.cmApiUrl}assets/${id}?sys.type[ne]=${(new Date()).valueOf()}`).then(data => {
                console.log(data.data);
                getFiles(true);
            });
        } else {
            $http.get(`${CONFIG.cmApiUrl}assets/${id}?sys.type[ne]=${(new Date()).valueOf()}`).then(data => {
                let version = data.data.sys.version;
                console.log('version: ', version);
                $scope.isProgress = true;

                let deleteConfig = {
                    errorMessage: T.HTTP_DELETE_ERROR_NOTIFICATION + labelSingle,
                    headers: {
                        'X-Contentful-Version': version
                    }
                };

                $http.delete(`${CONFIG.cmApiUrl}assets/${id}/published?sys.type[ne]=${(new Date()).valueOf()}`, deleteConfig).then(() => {
                    let putConfig = {
                        successMessage: labelSingle + T.HTTP_DELETE_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_DELETE_ERROR_NOTIFICATION + labelSingle,
                        headers: {
                            'X-Contentful-Version': version
                        }
                    };

                    $http.put(`${CONFIG.cmApiUrl}assets/${id}/archived?sys.type[ne]=${(new Date()).valueOf()}`, null, putConfig).then(() => {
                        $http.delete(`${CONFIG.cmApiUrl}assets/${id}?sys.type[ne]=${(new Date()).valueOf()}`).then(data => {
                            getFiles(true);
                        });
                    });
                }, (error) => {
                    $scope.isProgress = false;
                });
            });
        }
    };

    /***
     * Open Detail
     * @param id
     * @param file
     */
    $scope.openDetail = (id, file) => {
        if (file.sys.updatedAt) {
            $state.go('.', { id: id, file: file, search: $scope.search })
        }
    };

    /***
     * Add Files
     */
    $scope.addFiles = () => {
        let modalInstance = $uibModal.open({
            template: appFileView,
            controller: appFileCtrl,
            controllerAs: 'vm',
            resolve: {
                isMultipleSelection() {
                    return true;
                },
                isNoUpload() {
                    return false;
                },
                image() {
                    return null;
                }
            }
        });

        modalInstance.result.then(() => {
            getFiles();
        });
    };

    /***
     * Remove File
     * @param entryId
     */
    $scope.remove = (entryId) => {
        console.log('remove');

        if (!$scope.$root.modal) {
            let modalInstance = $uibModal.open({
                template: confirmDeleteView
            });

            modalInstance.result.then(() => {
                removeFile(entryId);
                $scope.$root.modal = null;
            }, () => {
                $scope.$root.modal = null;
            });

            $scope.$root.modal = modalInstance;
        }
    };

    /***
     * Re-upload file
     * @param file
     */
    $scope.reUplaod = (file) => {
        $scope.isProgress = true;
        console.log(file);
        if (!!file.sys.archivedAt) {
            ContentFulFactory.createAssetFromFiles()
                .then((space) => space.getAsset(file.sys.id))
                .then((asset) => {
                    return asset.unarchive();
                })
                .then((asset) => {
                    $timeout( () => {
                        return asset.publish();
                    }, 300);
                })
                .then((asset) => {
                    $timeout( () => {
                        $scope.isProgress = false;
                        ngToast.create({
                            className: 'toast-success',
                            content: `${T.FILE} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                            timeout: 4000
                        });
                        $state.go('^.file', {id: file.sys.id, page: 1});
                    }, 300)
                });
        } else {
            ContentFulFactory.createAssetFromFiles()
                .then((space) => space.getAsset(file.sys.id))
                .then((asset) => {
                    return asset.publish();
                })
                .then((asset) => {
                    $timeout( () => {
                        $scope.isProgress = false;
                        ngToast.create({
                            className: 'toast-success',
                            content: `${T.FILE} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                            timeout: 4000
                        });
                        $state.go('^.file', {id: file.sys.id, page: 1});
                    }, 300)
                })
        }
    };

    /***
     * Searchbar callback
     * @param word
     * @param keyCode
     */
    $scope.changed = (word,  keyCode = null) => {
        $scope.disabledSearch = true;
        let getData = (data) => {
            $scope.files = [];
            $scope.files = data.data.items;
            let total = $scope.files.length;
            $scope.page = 1;
            $scope.pagesTotal = Math.ceil(total / paginationResultsPerPage);
            $scope.paginationRange = UtilitiesFactory.paginationRange(page, CONFIG.paginationLinksOffset, $scope.pagesTotal);
            $scope.disabledSearch = false;

            _.forEach($scope.files, (file) => {
                file.isImage = false;
                console.log(file);
                if (file.fields.hasOwnProperty('file')) {
                    if (file.fields.file.en.hasOwnProperty('url')) {
                        file.isImage = file.fields.file.en.contentType.toLowerCase().indexOf('png') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('gif') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpg') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpeg') > -1;
                    } else if (file.fields.file.en.hasOwnProperty('upload')) {
                        file.isImage = file.fields.file.en.contentType.toLowerCase().indexOf('png') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('gif') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpg') > -1 ||
                            file.fields.file.en.contentType.toLowerCase().indexOf('jpeg') > -1;
                    }
                }

                file.sys.createdAt = moment(file.sys.createdAt).format("DD. MMMM YYYY");
            });
        };

        if (keyCode === 13 || word === '') {
            $scope.isProgressData = true;
            $http.get(`${CONFIG.cmApiUrl}assets?&query=${word}&sys.type[ne]=${(new Date()).valueOf()}&order=-sys.createdAt`).then((data) => {
                $scope.isProgressData = false;
                getData(data);
            });
        }
    };

    /***
     * Pagination callback
     */
    $scope.paginationCallback =  (page) => {
        $state.go('.', {page: page, search: $scope.search });
    };

    /***
     * Show more callback
     */
    $scope.getShowMore = () => {
        if ($scope.files.length > $scope.limit) {
            $scope.limit += paginationResultsPerPage;
        } else {
            $scope.isGetShowMore = false;
        }
    };

    // get files ID
    const curLoaction = $location.$$url;
    $scope.activeId = curLoaction.replace('/file/', '');

    // Init
    //if (!isMobile) {
        getFiles();
    //}

}



// WEBPACK FOOTER //
// ./src/app/views/app.sidenav/AppSideNavFilesCtrl.js